export const APP_BANNER_ID = "app-banner" as const
export const APP_WRAPPER_ID = "app-wrapper" as const
export const APP_LAYOUT_MAIN_CONTAINER_ID = "main-container" as const
export const APP_LAYOUT_MAIN_CONTENT_ID = "main-content" as const

export const ASIDE_DEFAULT_WIDTH = 512
export const ASIDE_MIN_WIDTH = 384
export const ASIDE_MAX_WIDTH = 1000
